var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.$t('About')))]),_vm._l((_vm.$t('about.content')),function(text,index){return _c('div',{staticClass:"content"},[_c('p',[_vm._v("\n\t\t\t"+_vm._s(text)+"\n\t      ")])])})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }